















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import Segment from '@/store/entities/tracing/segment';
import ListView from '@/components/helper/list-view.vue';
import SegmentForm from './form.vue';

class PageSegmentRequest extends PageRequest { }

@Component({
    components: { ListView, SegmentForm }
})
export default class Segments extends ListBase {
    pagerequest: PageSegmentRequest = new PageSegmentRequest();
    segment: Segment = new Segment();
    tabModel: any = null;
    modalSetting: any = {
        entity: "segment",
        title: 'Segmento',
        width: "400px"
    };

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }

    async afterSave() {
        let list: any = this.$refs.listView
        await list.getpage();
    }
    columns = [
        this.gCol('code', 'Codigo', 'text'),
        this.gCol('name', 'Nombre', 'text'),
        this.gCol('min_year', '>= Anios', 'text'),
        this.gCol('max_year', '<= Anios', 'text'),
        this.defaultActions()
    ]
    async created() {
    }
}
